'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _progress = require('./progress/progress.controler');

var _progress2 = _interopRequireDefault(_progress);

var _play = require('./play/play.controler');

var _play2 = _interopRequireDefault(_play);

var _time = require('./time/time.controler');

var _time2 = _interopRequireDefault(_time);

var _volume = require('./volume/volume.controler');

var _volume2 = _interopRequireDefault(_volume);

var _fullScreen = require('./full-screen/full-screen.controler');

var _fullScreen2 = _interopRequireDefault(_fullScreen);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  PlayControl: _play2.default,
  ProgressControl: _progress2.default,
  TimeControl: _time2.default,
  VolumeControl: _volume2.default,
  FullscreenControl: _fullScreen2.default
};
//# sourceMappingURL=default-controls.js.map



//////////////////
// WEBPACK FOOTER
// ./~/video-player/dist/src/ui/controls/default-controls.js
// module id = 1696
// module chunks = 1 2 3